module.exports = __webpack_public_path__ + "img/agent.dadded93.png";